import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from './constants';

export const DotIcon = ({ ariaLabel = 'Dot', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className, stroke, strokeWidth } = {
    ...DEFAULT_ICON_PROPS,
    ...{ height: 8, width: 8, stroke: '#FFFFFF' },
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill="currentcolor"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};
